<template>
  <div>
     <v-toolbar flat color="white">
      <v-toolbar-title>Benutzerverwaltung</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="triggerNewUserDialog()" v-if="checkForAdmin()">
        Neuer Benutzer
      </v-btn>
    </v-toolbar>
    <v-dialog v-model="addUserDialog" max-width="600px">
    <v-card >
          <v-card-title>
            <span class="headline">Benutzer anlegen</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="newUser.name" label="Name"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="newUser.email" label="E-Mail"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="newUser.password" label="Passwort"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-checkbox v-model="newUser.admin" label="Adminrechte"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="triggerNewUserDialog()">Abbrechen</v-btn>
            <v-btn color="blue darken-1" flat @click="saveNewUser()">Speichern</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-data-table style="width: 70vw;"
                  :headers="headers"
                  :items="users.items.items"
                  :rows-per-page-items="[5,10,20,50,100]"
                  :loading="isLoading"
                  :total-items="totalItems"
                  :must-sort="true"
                  :pagination.sync="pagination"
                  class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.admin ? 'Ja' : 'Nein' }}</td>
        <td class="text-xs-left">{{ props.item.created_at | formatDate }}</td>
        <td class="justify-center layout px-0" v-if="checkForAdmin()">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { authHeader } from '../_helpers';
import { settings } from '../settings';
export default {
  name: 'users',
  data() {
    return {
      dialog: false,
      addUserDialog: false,
      totalItems: 0,
      newUser: {
        name: '',
        email: '',
        password: '',
        admin: false
      },
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'name'
      },
      headers: [
        {
          text: 'Benutzername',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: true,
          value: 'email'
        },
        {
          text: 'Admin',
          align: 'left',
          sortable: false,
          value: 'admin'
        },
        {
          text: 'Angelegt',
          align: 'left',
          sortable: false,
          value: 'created_at'
        },
        {
          text: '',
          align: 'left',
          sortable: false
        }
      ]
    };
  },
  watch: {
    pagination(newValue, oldValue) {
      this.getDataFromApi();
    },
    users(newValue, oldValue) {
      console.log(newValue.items.total);
      this.totalItems = newValue.items.total;
    }
  },
  mounted() {
    this.getDataFromApi();
    this.checkForAdmin();
  },
  computed: {
    users() {
      return this.$store.state.users.all;
    },
    isLoading() {
      return this.$store.state.users.loading;
    }
  },
  methods: {
    checkForAdmin() {
      let user = JSON.parse(localStorage.getItem('user'));
      console.log(user);
      if (user.admin) {
        return true;
      } else {
        return false;
      }
    },
    getDataFromApi() {
      const perpage = this.pagination.rowsPerPage;
      const page = this.pagination.page;
      const sortby = this.pagination.sortBy;
      const descending = this.pagination.descending;

      this.$store.dispatch('users/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
    },
    triggerNewUserDialog() {
      this.addUserDialog = !this.addUserDialog;
      this.newUser = {
        name: '',
        email: '',
        password: '',
        admin: false
      };
    },
    saveNewUser() {
      const name = this.newUser.name;
      const email = this.newUser.email;
      const admin = this.newUser.admin;
      const password = this.newUser.password;
      this.$store.dispatch('users/addNew', { name, password, email, admin });
      this.addUserDialog = false;
    },
    deleteItem(item) {
      const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
      };
      console.log(requestOptions);
      return fetch(`${settings.apiUrl}/users/` + item.id, requestOptions).then(
        response => console.log(response)
      );
    }
  }
};
</script>
